import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { http, errMsg } from "@/lib/api";
import { LogoMark } from "@/components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      localStorage.setItem("mp_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-5 py-16 relative overflow-hidden">
      <div aria-hidden="true" className="absolute w-[80vw] h-[80vw] max-w-[700px] max-h-[700px] rounded-full bg-[radial-gradient(circle,rgba(255,85,0,0.25),transparent_65%)] blur-2xl" />
      <form onSubmit={submit} data-testid="admin-login-form" className="relative w-full max-w-md rounded-[2rem] border border-white/10 bg-[#16161A]/90 backdrop-blur-xl p-8 sm:p-10">
        <LogoMark className="w-12 h-12" />
        <h1 className="mt-6 font-display uppercase text-4xl tracking-[-0.03em]">Area riservata</h1>
        <p className="mt-2 text-zinc-400 text-sm">Accedi per gestire prodotti e prezzi del menù.</p>
        <label className="mt-8 block text-sm font-semibold" htmlFor="email">Email</label>
        <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" className="field mt-2" autoComplete="username" />
        <label className="mt-5 block text-sm font-semibold" htmlFor="password">Password</label>
        <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" className="field mt-2" autoComplete="current-password" />
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-primary w-full justify-center mt-8 disabled:opacity-60">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Entra
        </button>
        <Link to="/" data-testid="admin-login-back" className="mt-6 inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors">
          <ArrowLeft className="w-4 h-4" /> Torna al sito
        </Link>
      </form>
    </div>
  );
}
